<template>
  <div>
    <treeselect
      v-show="inputVisible"
      ref="thetree"
      v-model="theclct"
      @close="treeclose"
      @select="collectionselect"
      :disable-branch-nodes="true"
      :options="options"
      :default-expand-level="1"
      :flatten-search-results="true"
    />
    <el-button v-show="!inputVisible" style="width: 100%" @click="showtree">{{
      $store.state.collection.label
    }}</el-button>
  </div>
</template>

<script>
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import treeprocess from "@/components/utility/treeprocess";

export default {
  // register the component
  components: { Treeselect },
  data() {
    return {
      inputVisible: false,
    };
  },
  
  computed: {
    theclct: {
      get() {
        return this.$store.state.clct;
      },
      set(val) {
        if (val != undefined) {
          this.$store.commit("setcollectionbyval", val);  
        }
      },
    },
    options() {
      //return this.$store.state.collections;
      //将来collections中的value换成id
      let origin = this.$store.state.collections;
      let newtype = JSON.parse(JSON.stringify(origin));
      newtype.forEach((obj) => {
        delete Object.assign(obj, { ["id"]: obj["value"] })["value"];
      });

      return treeprocess(newtype);
    },
  },
  methods: {
    collectionselect(node) {
      this.$emit("select",node.id);
    },
    treeclose() {
      this.inputVisible = false;
      this.$emit("treeclose");
    },
    showtree() {
      this.inputVisible = true;
      this.$emit("fullfortree");
      this.$nextTick((_) => {
        this.$refs.thetree.openMenu();
        this.$refs.thetree.focusInput();
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/presentation/table/treeselect.vue